<template>
  <div>
    <v-menu :nudge-bottom="20">
      <template v-slot:activator="{ on }">
        <i
          class="fa fa-ellipsis-h"
          aria-hidden="true"
          style="cursor: pointer; margin: 10px"
          v-on="on"
        >
        </i>
      </template>
      <!-- เปลี่ยนรหัสผ่าน -->
      <div
        v-if="showChangePassword"
        style="color: black; border-radius: 8px; display: flex; align-items: center; z-index: 100"
        @click="
          showTooltip = false
          memberInfo ? $emit('store') : $emit('modalChangePassword')
        "
        class="btn white"
      >
        <img
          v-if="memberInfo"
          src="/static/img/mail.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        <img
          v-else
          src="/static/img/TooltipPassword.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />

        &nbsp;เปลี่ยนรหัสผ่าน
      </div>
      <div v-if="showChangePassword" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>
      <!-- แชท -->
      <!-- <a
        :href="'https://localhost:3000/th/livechat'"
        target="_blank"
        v-if="showChat"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="$emit('Print')"
        class="btn white"
      >
        <img
          src="/static/img/TooltipChat.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;แชท
      </a> -->
      <div
        v-if="showChat && !showChatLink"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="$emit('Chat')"
        class="btn white"
      >
        <img
          src="/static/img/TooltipChat.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;แชท
      </div>
      <!-- <a
        target="_blank"
        v-else-if="showChat && showChatLink && SERVER_URL != ''"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="
          showTooltip = false
          $emit('Chat')
        "
        href="https://localhost:3000/th/livechat"
        class="btn white"
      > -->
      <!-- </a> -->
      <div v-if="showChat && !showChatLink" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>
      <div
        v-else-if="showChat && showChatLink && this.datas.item.userid !== 'null__undefined'"
        @click="goToLivechat"
        style="
          color: black;
          border-radius: 8px;
          display: flex;
          align-items: center;
          padding: 4px 16px;
        "
      >
        <img
          src="/static/img/TooltipChat.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;แชท
      </div>
      <div
        v-if="showChat && showChatLink && this.datas.item.userid !== 'null__undefined'"
        style="width: 100%; border-bottom: 1px solid #0c2f53"
      ></div>
      <!-- Print -->
      <div
        v-if="showPrint"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="$emit('Print')"
        class="btn white"
      >
        <img
          src="/static/img/TooltipPrint.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;ปริ้นท์
      </div>
      <div v-if="showPrint" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>
      <!-- Download -->
      <div
        v-if="showDownload"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="$emit('Download')"
        class="btn white"
      >
        <img
          src="/static/img/TooltipDownload.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;ดาวน์โหลด
      </div>
      <div v-if="showDownload" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>
      <!-- แก้ไข -->
      <div
        v-if="showIsEdit"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="
          showTooltip = false
          $emit('modalEdit')
        "
        class="btn white"
      >
        <img
          src="/static/img/TooltipEdit.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;แก้ไข
      </div>
      <div v-if="showIsEdit" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>

      <!-- ดูตัวอย่าง -->
      <div
        v-if="showViewExample"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="
          showTooltip = false
          $emit('ViewExample')
        "
        class="btn white"
      >
        <img
          src="/static/img/TooltipView.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;ดูตัวอย่าง
      </div>
      <div v-if="showViewExample" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>

      <!-- copy -->
  
      <div
        v-if="showCopy"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="
          showTooltip = false
          $emit('Copy')
        "
        class="btn white"
      >
        <img src="/static/img/Copy.png" alt class="responsive-img mb-1" style="height: 22px" />
        &nbsp;&nbsp;คัดลอก
      </div>
      <div
        v-if="showCopy && showIsEdit"
        style="width: 100%; border-bottom: 1px solid #0c2f53"
      ></div>
      <!-- ดู -->
      <div v-if="showView" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>
      <div
        v-if="showView"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="
          showTooltip = false
          $emit('View')
        "
        class="btn white"
      >
        <img
          src="/static/img/TooltipView.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;ดู
      </div>

      <!-- ลบ -->
      <div v-if="showDelete && !showIsEdit && !showDownload" style="width: 100%; border-bottom: 1px solid #0c2f53"></div>
      <div
        v-if="showDelete"
        style="color: black; border-radius: 8px; display: flex; align-items: center"
        @click="
          showTooltip = false
          $emit('Delete')
        "
        class="btn white"
      >
        <img
          src="/static/img/TooltipDelete.png"
          alt
          class="responsive-img mb-1"
          style="height: 22px"
        />
        &nbsp;&nbsp;ลบ
      </div>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    datas: Object,
    showChangePassword: Boolean,
    showPrint: Boolean,
    showDownload: Boolean,
    showChat: Boolean,
    showChatLink: Boolean,
    showDelete: Boolean,
    showCopy: Boolean,
    showView: Boolean,
    showViewExample: Boolean,
    showIsEdit: {
      type: Boolean,
      default: true,
    },
    memberInfo: Boolean,
  },
  data() {
    // console.log('this.data', this.datas.item.line_name)
    return {
      showTooltip: false,
      showChangePassword: false,
      showPrint: false,
      showDownload: false,
      showChat: false,
      showDelete: false,
      showIsEdit: true,
      showCopy: true,
      showViewExample: true,
      showEdit: {},
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
    }),
  },
  methods: {
    showModalEdit(item) {
      this.showEdit = item.typeid
    },
    goToLivechat: function () {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: this.datas.item.userid,
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.v-menu__content {
  border-radius: 12px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/TooltipTable.vue